export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.4.20-1259.07",
  commitId: "e74a83b396b4fdd26165c78c5d202cc2f7dee115",
  commitTime: "2026-04-20T12:59:07.000Z",
});
